@if (isLoaded) {
  <rt-activities-list
    infiniteScroll
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="500"
    [infiniteScrollContainer]="scrollable.getElementRef()"
    [scrollWindow]="false"
    [activities]="activities"
    [canManageCandidates]="canManageCandidate"
    [showNewTriggeredIcon]="hasWorkflowAutomations"
    (activityItemClick)="openActivity($event)"
    (scrolled)="loadMore()"
  />
  @if (!activities.length) {
    <rt-empty-state
      [icon]="'notifications-none'"
      [title]="'app.activities.no_activities' | translate"
      [desc]="'app.activities.no_activities_desc' | translate"
      margin-top
    />
  }
} @else {
  <rt-spinner />
}
